/* MultiEditAction.js */

"use strict";
const _ = require("lodash");

class MultiEditAction {
    constructor(logger, gameEditor, activeView, steveIo, userFeedback) {
        this._logger = logger;
        this._activeView = activeView;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = userFeedback;
        this.run = this.run.bind(this);
    }
    run() {
        let selectedDeviceIds = _.get(this._activeView.getSelectedDeviceIds(), "selectedRows", []);
        if (selectedDeviceIds.length > 10000) {
            return this._modalUserFeedback.displayNotification(
                "The multi-edit action is limited to 10,000 devices. Please reduce the number of selected devices and try again.",
                {
                    title: "Edit Devices - Selection limit exceeded",
                }
            );
        }
        return Promise.resolve().then(() => {
            this._activeView.openDeviceInstanceEditor(selectedDeviceIds);
        });
    }
}
module.exports = MultiEditAction;

MultiEditAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.activeView",
    "$teve.io",
    "$teve.ui.userFeedback",
];

MultiEditAction.$displayDetails = {
    type: "Action",
    name: "MultiEditAction",
    icon: "common.multi_edit",
    shown: true,
    title: "Edit devices",
    order: 4,
};
